export default __webpack_public_path__ + "static/media/gallery - story - three brothers (2)_00.3a8388b5.jpg";